import * as React from "react";
import styled from "@emotion/styled";

export type StepProgressBarProps = {
  progress: {
    step1: boolean;
    step2: boolean;
    step3: boolean;
    step4: boolean;
  };
  backgroundColor?: string;
};

const StyledStepProgressBar = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDot = styled.div<{
  isActive: boolean;
  backgroundColor?: string;
}>`
  height: 16px;
  width: 16px;
  background-color: ${({ isActive, backgroundColor }) => (isActive ? backgroundColor : "#D6D6D6")};
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 24px;
  &: first-child {
    margin-left: 0;
  }
`;

const StepProgressBar = ({ progress, backgroundColor }: StepProgressBarProps) => {
  return (
    <StyledStepProgressBar>
      <StyledDot backgroundColor={backgroundColor} isActive={true} />
      <StyledDot backgroundColor={backgroundColor} isActive={progress.step1} />
      <StyledDot backgroundColor={backgroundColor} isActive={progress.step2} />
      <StyledDot backgroundColor={backgroundColor} isActive={progress.step3} />
      <StyledDot backgroundColor={backgroundColor} isActive={progress.step4} />
    </StyledStepProgressBar>
  );
};

export default StepProgressBar;
